import { render, staticRenderFns } from "./SmallText.vue?vue&type=template&id=0b0174fd"
import script from "./SmallText.vue?vue&type=script&lang=js"
export * from "./SmallText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports